import OnboardingPage from '../pages/Onboarding/OnboardingPage'
import PaymentCallbackPage from '../pages/PaymentCallbackPage/PaymentCallbackPage'
import React from 'react'
import RegisterSection from '../pages/Onboarding/sections/register/RegisterSection'
import PaymentSection from '../pages/Onboarding/sections/payment/PaymentSection'
import ValidationSection from '../pages/Onboarding/sections/validation/ValidationSection'
import PublicRoute from '../components/RouteVisibility/PublicRoute/PublicRoute'

export const ONBOARDING_PATH = '/onboarding',
	PAYMENT_CALLBACK_PATH = 'paid',
	PAYMENT_PATH = 'payment',
	VALIDATION_PATH = 'validation',
	TIERS_PATH = 'tiers',
	REGISTER_PATH = 'register'

export const ONBOARDING_ROUTES = [
	{
		path: ONBOARDING_PATH,
		element: <PublicRoute />,
		children: [
			{
				path: '',
				element: <OnboardingPage />,
				children: [
					{
						path: '',
						element: <RegisterSection />,
					},
					{
						path: PAYMENT_PATH,
						element: <PaymentSection />,
					},
					{
						path: VALIDATION_PATH,
						element: <ValidationSection />,
					},
				],
			},
			{
				path: PAYMENT_CALLBACK_PATH,
				element: <PaymentCallbackPage />,
			},
		],
	},
]
